import { SVGProps } from 'react';

const IcNext = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none' {...props}>
      <path
        d='M4 10.5C3.85 10.5 3.75 10.45 3.65 10.35C3.45 10.15 3.45 9.85 3.65 9.65L7.3 6L3.65 2.35C3.45 2.15 3.45 1.85 3.65 1.65C3.85 1.45 4.15 1.45 4.35 1.65L8.35 5.65C8.55 5.85 8.55 6.15 8.35 6.35L4.35 10.35C4.25 10.45 4.15 10.5 4 10.5Z'
        fill='#777D7C'
      />
    </svg>
  );
};

export default IcNext;
